import React from "react";
import { Grid } from "semantic-ui-react";
import "./App.css";
import { connect } from "react-redux";

import ColorPanel from "./ColorPanel/ColorPanel";
import SidePanel from "./SidePanel/SidePanel";

import CloudsFeedMetaPanel from "./MetaPanel/CloudsFeedMetaPanel";
import Clouds from "./SidePanel/Clouds";
// prettier-ignore
const CloudsFeed = ({ currentUser, currentChannel, isPrivateChannel, userPosts, primaryColor, secondaryColor, cloudsFeedOn }) => (
  <React.Fragment>
  <SidePanel
      key={currentUser && currentUser.uid}
      currentUser={currentUser}
      primaryColor="#4267B2"
    />
  <Grid columns="equal" className="app" style={{ background: secondaryColor }}>
    {/* <ColorPanel
      key={currentUser && currentUser.name}
      currentUser={currentUser}
    />  */}
    {/* <SidePanel
      key={currentUser && currentUser.uid}
      currentUser={currentUser}
      primaryColor="#4267B2"
    />
     */}
    
    <Grid.Column style={{ marginLeft:"1%", marginRight:"18%", marginTop: 20 }}>
      <Clouds bookmarkedClouds={false} currentUser={currentUser}/>
    </Grid.Column>
    

    <Grid.Column width={3} style={{position:"absolute",right:"0%", marginTop: 20 }}>
      <CloudsFeedMetaPanel
        key={currentChannel && currentChannel.name}
        userPosts={userPosts}
        currentChannel={currentChannel}
        isPrivateChannel={isPrivateChannel}
        currentUser={currentUser}
        bookmarkedClouds={false}
      />
    </Grid.Column>
  </Grid>
  </React.Fragment>
  
);

const mapStateToProps = (state) => ({
  currentUser: state.user.currentUser,
  currentChannel: state.channel.currentChannel,
  isPrivateChannel: state.channel.isPrivateChannel,
  userPosts: state.channel.userPosts,
  primaryColor: state.colors.primaryColor,
  secondaryColor: state.colors.secondaryColor,
});

export default connect(mapStateToProps)(CloudsFeed);



// WEBPACK FOOTER //
// ./src/components/CloudsFeed.js